import Language from '../../../entity/Language';
import { useGetInsightCategoriesQuery } from '../../../generated/graphql';

const useGetInsightCategories = ({ language, organizationId }: { language: Language; organizationId?: string }) => {
  const { data, loading, error } = useGetInsightCategoriesQuery({
    variables: { language, organizationId },
  });

  return { insightCategories: data?.insightCategoriesByOrganization, loading, error };
};

export default useGetInsightCategories;
